<template>
    <v-container fluid class="py-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>
            <v-col cols="12" style="margin-top: -60px">
                <v-row>
                    <v-col cols="12" lg="4" md="12" sm="12">
                        <v-card>
                            <v-list two-line subheader>
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <v-icon color="#008dd4" x-large>mdi-account-group</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title><strong>Total Alumnos validados</strong></v-list-item-title>
                                        <v-list-item-subtitle class="text-h4">{{ total_verified }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                    <v-col cols="12" lg="4" md="12" sm="12">
                        <v-card>
                            <v-list two-line subheader>
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <v-icon color="#008dd4" x-large>mdi-bookshelf</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title><strong>Total de cursos disponibles</strong></v-list-item-title>
                                        <v-list-item-subtitle class="text-h4">{{ total_courses }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                    <v-col cols="12" lg="4" md="12" sm="12">
                        <v-card>
                            <v-list two-line subheader>
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <v-icon color="#008dd4" x-large>mdi-currency-usd</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title><strong>Ingreso total del día</strong></v-list-item-title>
                                        <v-list-item-subtitle class="text-h4">{{ total_daily }}{{ daily % 1 === 0 ? '.00' : '' }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                </v-row>    
            </v-col>
            <v-col cols="12">
                <v-row>
                    <v-col cols="12" lg="6">
                        <v-card>
                            <v-card-title>Registrados por curso del día</v-card-title>
                            <v-card-text>
                                <v-simple-table v-if="Object.keys(registered_per_course_day).length > 0">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>Curso</th>
                                                <th>Cantidad</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(registered, index) in registered_per_course_day" :key="index">
                                                <td>{{ registered[0].course.name }}</td>
                                                <td>{{ registered.length }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <p class="text-center mb-0" v-else>Sin registros disponibles</p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-card>
                            <v-card-title>Validados por curso del día</v-card-title>
                            <v-card-text>
                                <v-simple-table v-if="Object.keys(verified_per_course_day).length > 0">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>Curso</th>
                                                <th>Cantidad</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(verified, index) in verified_per_course_day" :key="index">
                                                <td>{{ verified[0].course.name }}</td>
                                                <td>{{ verified.length }}</td>
                                            </tr>
                                            <tr>
                                                <td> <strong>Total</strong></td>
                                                <td> <strong>{{ verified_per_day }}</strong></td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <p class="text-center mb-0" v-else>Sin registros disponibles</p>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col cols="12">
                        <v-card>
                            <v-card-title>Cursos</v-card-title>
                            <v-card-text>
                                <v-data-table :headers="headers" :items="courses" sort-by="id" sort-desc :single-expand="true"  show-expand>
                                    <template  v-slot:expanded-item="{ headers, item }">
                                        <td :colspan="headers.length" class="px-0">
                                            <v-simple-table>
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-center">Día</th>
                                                            <th class="text-center">Hora de inicio</th>
                                                            <th class="text-center">Hora de termino</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr class="text-center" v-for="(schedule, index) in item.schedule" :key="index">
                                                            <td>{{ schedule.day }}</td>
                                                            <td>{{ schedule.start_time }}</td>
                                                            <td>{{ schedule.end_time }}</td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </td>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-on="on" v-bind="attrs" @click="() => { course = item; students_dialog = !students_dialog}">
                                                    <v-icon>mdi-account-group</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Estudiantes</span>
                                        </v-tooltip>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <students :dialog="students_dialog" :course="course"></students>
    </v-container>
</template>
<script>

import students from '../courses/students'

export default {
    props:['total_verified','total_courses','daily','daily_inscriptions','registered_day','registered_per_course_day','verified_per_day','verified_per_course_day','courses'],
    components:{ students },
    data: () => ({
        students_dialog:false,
        course:"",
        headers:[
            { text:'ID', value:'id' },
            { text:'Nombre(s)', value:'name' },
            { text:'Inicio', value:'start_date' },
            { text:'Máximo', value:'student_limit'},
            { text:'Registrados', value:'total_registered' },
            { text:'Validados', value:'total_verified' },
            { text:'Acciones', value:'actions' },
            { text: 'Horario', value: 'data-table-expand' },
        ],
    }),
    computed:{
        total_daily:function(){
            return this.daily.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    }
}
</script>